import type {
  WebFurnitureBulkError,
  WebFurniturePackage,
  WebFurniturePreviewOrder,
} from "../webfurnitureApi";
import { fornitoreViaHttp, nomeFornitoreMail } from "../webfurnitureApi";
import { PackagesConfirmDialog } from "./PackagesConfirmDialog";

interface WebFurnitureConfirmDialogProps {
  previews: WebFurniturePreviewOrder[];
  previewErrors: WebFurnitureBulkError[];
  sending: boolean;
  sendError: string | null;
  onConfirm: (overrides: Record<string, WebFurniturePackage[]>) => void;
  onClose: () => void;
  /** Id backend del fornitore (``webfurniture``, ``aurora``, ``mauroferretti``).
   *  ⛔ Prima era assente e il popup diceva «Web Furniture» a chiunque: chi
   *  ordinava ad Aurora leggeva il nome di un ALTRO fornitore proprio
   *  nell'istante in cui conferma un acquisto. */
  fornitore?: string;
}

/**
 * Popup di conferma invio Web Furniture (spec 2026-06-18). Wrapper thin su
 * `PackagesConfirmDialog` (editor colli condiviso): testi WF + prefisso
 * testid `wf`. A differenza di Cosma i colli default sono multi-cartone dal
 * catalogo WF (nessuna regola "1 collo"), ma l'editor è identico.
 */
export function WebFurnitureConfirmDialog({
  previews,
  previewErrors,
  sending,
  sendError,
  onConfirm,
  onClose,
  fornitore = "webfurniture",
}: WebFurnitureConfirmDialogProps) {
  const nome = nomeFornitoreMail(fornitore);
  const comeParte = fornitoreViaHttp(fornitore)
    ? "L'ordine verrà inviato al portale con la LDV allegata."
    : "La mail con la LDV verrà aperta in Thunderbird.";
  return (
    <PackagesConfirmDialog
      previews={previews}
      previewErrors={previewErrors}
      sending={sending}
      sendError={sendError}
      onConfirm={onConfirm}
      onClose={onClose}
      testIdPrefix="wf"
      titleId="wf-confirm-title"
      title={`Confermi l'invio a ${nome}?`}
      subtitle={(n) =>
        `${n} ordin${n === 1 ? "e" : "i"} — controlla spedizione e colli, poi conferma. ${comeParte}`
      }
      confirmLabel={(n) => `Conferma e invia (${n})`}
    />
  );
}
